/*
 * @Author: K
 * @Date: 2022-04-08 16:23:14
 * @LastEditors: owen
 * @LastEditTime: 2022-04-19 18:54:41
 * @FilePath: \app-pcweb\src\store\modules\HeadPortrait.js
 */
const Exchange = {
    state: {
      setServicePromptObj: {},
    },
    mutations: {
      setServicePromptObj(state, data) {
        state.setServicePromptObj = data;
      },
    },
    getters: {
      getServicePromptObj(state) {
        return state.setServicePromptObj;
      },
    },
  };
  
  export default Exchange;
  